import { Flex, Loading, Typography } from 'components';
import React, { ReactElement, useState } from 'react';
import styled, { ColorsTypes } from 'styled-components';
import { saveAs } from 'file-saver';

import {
  // mdiPresentationPlay,
  mdiBookOpenVariant,
  // mdiFileDownloadOutline,
} from '@mdi/js';
import Icon from '@mdi/react';
import { DownloadsItemState } from 'features/downloads';
import { useSchool } from 'features/school';
import { request } from 'app/utils';
import { AxiosResponse } from 'axios';
import { useTracking } from 'features/tracking';

const DocumentTypography = styled('a')`
  color: ${({ theme }) => theme.colors.primary_600};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const DownloadIcon = styled(Icon).attrs({
  path: mdiBookOpenVariant,
})<{ color: ColorsTypes }>`
  display: block;
  color: ${({ theme, color }) => theme.colors[color]};

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 1.5rem;
      height: 1.5rem;

      ${mediaQueries.desktop} {
        width: 1.8rem;
        height: 1.8rem;
      }
    `;
  }}
`;

interface DownloadsBoxProps {
  downloads: DownloadsItemState[];
}

const DownloadsBox = ({ downloads }: DownloadsBoxProps): ReactElement => {
  const { apiGatewayUrl, schoolAlias } = useSchool();
  const [loading, setLoading] = useState(false);
  const { eventTracker } = useTracking();
  const [perncentage, setPercentage] = useState(0);

  const getDownload = (downloadUrl: string, downloadFileName: string) => {
    setLoading(true);

    eventTracker({ category: 'Módulos', action: 'Download', label: `Arquivo: ${downloadFileName}` });

    request({
      url: downloadUrl,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = total === undefined ? 0 : Math.floor((loaded / total) * 100);

        setPercentage(percentCompleted);
      },
    })
      .then((response: AxiosResponse<Blob>) => {
        setLoading(false);

        eventTracker({ category: 'Módulos', action: 'Download', label: `Arquivo: ${downloadFileName}` });

        // if (downloadFileName.toLowerCase().endsWith('pdf')) {
        //   //Create a Blob from the PDF Stream
        //   const file = new Blob([response.data], { type: 'application/pdf' });
        //   //Build a URL from the file
        //   const fileURL = URL.createObjectURL(file);
        //   //Open the URL on new Window
        //   const pdfWindow = window.open();
        //   if (pdfWindow != null) {
        //     pdfWindow.location.href = fileURL;
        //   }
        // } else {
        // }
        saveAs(response.data, downloadFileName);

        setTimeout(() => {
          setPercentage(0);
        }, 0);
      })
      .catch((error) => {
        setLoading(false);
        setPercentage(0);
        // console.log(error);
      });
  };

  return (
    <>
      {loading && <Loading alpha={0.8} label={`Por favor, aguarde.<br />${perncentage ? `${perncentage}%` : ``}`} />}

      <Flex bg={schoolAlias === 'b3' ? 'dark_150' : 'white'} minWidth={{ m: '100%' }} borderRadius={4} alignItems="flex-start" flexWrap="nowrap">
        <Flex flexGrow={0} width={{ m: 60, d: 90 }} flexShrink={0} alignItems="center" justifyContent="center" pt={{ m: 18, d: 25 }}>
          <DownloadIcon color={schoolAlias === 'b3' ? 'white' : 'dark_150'} />
        </Flex>

        <Flex flexDirection="column" py={{ m: 20, d: 30 }} pr={{ m: 20 }}>
          <Typography type="type3" color={schoolAlias === 'b3' ? 'white' : 'dark_150'} fontWeight="bold" mb={{ m: '10px', d: '10px' }}>
            Material de apoio
          </Typography>

          {downloads.map((download, index) => {
            return (
              <React.Fragment key={`download-box-${index.toString()}`}>
                {download.downloadType === 0 && (
                  <DocumentTypography href={download.downloadUrl} target="_blank">
                    {download.name}
                  </DocumentTypography>
                )}

                {(download.downloadType === 1 || download.downloadType === 2) && (
                  <DocumentTypography onClick={() => getDownload(download.downloadUrl, download.downloadFileName)}>
                    {download.name}
                  </DocumentTypography>
                )}
              </React.Fragment>
            );
          })}
        </Flex>
      </Flex>

      {/* <Flex flexDirection="column" width={{ m: '100%', d: 360 }} mt={{ m: 30, d: 0 }} ml={{ d: 60 }} flexShrink={0}>
        <Flex flexGrow={0} bg="white" alignItems="flex-start" flexWrap="nowrap">
         
        </Flex>
      </Flex> */}
    </>
  );
};

export default DownloadsBox;
